import { useTranslation } from "react-i18next";
import Header from "../components/Header";
import Footer from "../components/Footer";
import ProductCard from "../components/ProductCard";
import SEOHead from "../components/SEOHead";
import { softwareApplicationSchema, productsBreadcrumbSchema } from "../data/structuredData";

export default function Products() {
  const { t } = useTranslation();

  const CATALOG_PRODUCTS = [
    {
      product_id: "max-os-cloud",
      name: t('products_page.max_os_cloud'),
      card_title: t('products_page.max_os_cloud').toUpperCase(),
      tagline: t('products_page.max_os_cloud_tagline'),
      price: 49,
      billing: "mo",
      badge: t('products_page.trial_included'),
      features: [
        t('products_page.max_os_cloud_f1'),
        t('products_page.max_os_cloud_f2'),
        t('products_page.max_os_cloud_f3'),
        t('products_page.max_os_cloud_f4'),
      ],
      cta_label: t('products_page.start_free_trial'),
      contact_only: false,
      cta_href: "/register",
    },
    {
      product_id: "max-os-enterprise",
      name: t('products_page.enterprise'),
      card_title: t('products_page.enterprise').toUpperCase(),
      tagline: t('products_page.enterprise_tagline'),
      price: 879,
      billing: "mo",
      from_price: true,
      badge: null,
      features: [
        t('products_page.enterprise_f1'),
        t('products_page.enterprise_f2'),
        t('products_page.enterprise_f3'),
        t('products_page.enterprise_f4'),
      ],
      cta_label: t('products_page.contact_sales'),
      cta_href: "mailto:sales@maxemployee.com",
    },
  ];

  const PRODUCT_MICROCOPY = {
    "max-os-cloud": t('products_page.trial_included'),
    "max-os-enterprise": null,
  };

  return (
    <div className="min-h-screen bg-[#09090B] text-white">
      <SEOHead
        title={`${t('products_page.title_1')} ${t('products_page.title_2')} — Max Employee`}
        description={t('products_page.subtitle')}
        url="/products"
        image="/og-image-homepage.png"
        structuredData={[softwareApplicationSchema, productsBreadcrumbSchema]}
      />
      <Header />
      <section className="border-b border-zinc-900" aria-labelledby="products-hero-heading">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-20 grid-bg relative">
          <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-amber-500 mb-4" aria-hidden="true">
            // {t('products_page.section_label').replace('// ', '').toUpperCase()}
          </div>
          <h1 id="products-hero-heading" className="font-display text-3xl sm:text-5xl md:text-6xl uppercase leading-[0.95]">
            {t('products_page.title_1')}
            <br />
            {t('products_page.title_2')}
          </h1>
          <p className="text-zinc-400 mt-6 max-w-xl text-lg">
            {t('products_page.subtitle')}
          </p>
        </div>
      </section>

      <main id="main-content" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-8 sm:py-16">
        <div
          data-testid="products-grid"
          className="grid grid-cols-1 md:grid-cols-2 gap-px bg-zinc-900"
          role="list"
          aria-label={t('products_page.title_1')}
        >
          {CATALOG_PRODUCTS.map((p) => (
            <ProductCard key={p.product_id} product={p} microcopy={PRODUCT_MICROCOPY[p.product_id] || null} />
          ))}
        </div>
      </main>
      <Footer />
    </div>
  );
}
